var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return ( _vm.$store.getLoading()[0])?_c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"overlayMain"},[_c('div',{staticClass:"loader-box"},[_c('div',{staticClass:"spinner"}),_vm._v(" "),_c('div',{staticClass:"loader-text"},[_vm._v(_vm._s(_vm.$store.getLoading()[1]))])])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5baf44f4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/loader.vue
// module id = null
// module chunks = 